import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "OrderNbr" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-plus" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_12 = { for: "CreatedBy" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { for: "DateSent" }
const _hoisted_19 = { class: "col-md-6 form-group" }
const _hoisted_20 = { for: "ReceiverName" }
const _hoisted_21 = ["disabled", "placeholder"]
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { for: "recieReceiverTelpient_phone" }
const _hoisted_24 = ["disabled", "placeholder"]
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.DeliveryNbr.$error}])
            }, [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.language.order_nbr) + "  ", 1),
                (_ctx.dataRecord.IdDelivery == 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:;",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateOrderNbr && _ctx.generateOrderNbr(...args)))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "OrderNbr",
                class: "form-control capletter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.DeliveryNbr) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDelivery != 0,
                placeholder: '(' + _ctx.language.deliv_nbr.toLowerCase() + ')',
                maxlength: "15",
                autocomplete: "off",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_10), [
                [_vModelText, _ctx.dataRecord.DeliveryNbr]
              ]),
              (_ctx.v$.dataRecord.DeliveryNbr.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.dataRecord.DeliveryNbr.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.CreatedBy.$error}])
            }, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.created_by), 1),
              _withDirectives(_createElementVNode("select", {
                id: "CreatedBy",
                name: "CreatedBy",
                class: "form-control-sel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.CreatedBy) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDelivery != 0
              }, [
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.language.select_staff), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theListStaff, (custRec) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: custRec.UserId,
                    value: custRec.Email
                  }, _toDisplayString(`${custRec.FirstName + ' ' + custRec.LastName}`), 9, _hoisted_15))
                }), 128))
              ], 8, _hoisted_13), [
                [_vModelSelect, _ctx.dataRecord.CreatedBy]
              ]),
              (_ctx.v$.dataRecord.CreatedBy.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.v$.dataRecord.CreatedBy.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.oper_date), 1),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.dataRecord.DeliveryDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.DeliveryDate) = $event)),
                format: "dd/MM/yyyy",
                cancelText: _ctx.language.cancel,
                selectText: _ctx.language.select,
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDelivery != 0
              }, null, 8, ["modelValue", "cancelText", "selectText", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.language.reciepient_name), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "ReceiverName",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.ReceiverName) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDelivery != 0,
                placeholder: '(' + _ctx.language.reciepient_name.toLowerCase() + ')',
                maxlength: "15",
                autocomplete: "off",
                onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_21), [
                [_vModelText, _ctx.dataRecord.ReceiverName]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.language.reciepient_phone), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "ReceiverTel",
                class: "form-control number",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.ReceiverTel) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDelivery != 0,
                placeholder: '(' + _ctx.language.reciepient_phone.toLowerCase() + ')',
                maxlength: "12",
                autocomplete: "off",
                onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_24), [
                [_vModelText, _ctx.dataRecord.ReceiverTel]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_27),
            (_ctx.dataRecord.IdDelivery == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid || _ctx.isSavingRecord
                }, [
                  (_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}